import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function DollarCircleFillIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <>
        <path d="M14 13a1 1 0 0 1 0 2h-1v-2zM11 9v2h-1a1 1 0 0 1-.995-.901L9 10a1 1 0 0 1 1-1z" />
        <path
          d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m0 4a1 1 0 0 0-1 1v1h-1a3 3 0 0 0-3 3l.015.297A3 3 0 0 0 10 13h1v2H8a1 1 0 1 0 0 2h3v1a1 1 0 1 0 2 0v-1h1a3 3 0 0 0 0-6h-1V9h3a1 1 0 1 0 0-2h-3V6a1 1 0 0 0-1-1"
          clipRule="evenodd"
        />
      </>
    </Icon>
  );
}

DollarCircleFillIcon.displayName = 'DollarCircleFillIcon';
